import React from 'react';

import { Box } from '@rbilabs/component-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import useMediaQuery from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const AdditionalInformation = styled.div`
  color: ${Styles.color.primary};
  text-align: center;
  font-size: 0.9375rem;
  margin-top: 2rem;
`;

const DeliveryDisclaimer = styled.p`
  text-align: center;
  font-size: 0.9375rem;
  margin: 0.5rem 0;
`;

interface IDeliveryFormFooterProps {
  addressString: string;
  setCreateAddressView: (show: boolean) => void;
  showDeliveryAddresses: boolean;
}

const DeliveryAddressFormFooter: React.FC<IDeliveryFormFooterProps> = ({
  addressString,
  setCreateAddressView,
  showDeliveryAddresses,
}) => {
  const { formatMessage } = useIntl();
  const enableSimplifiedDelivery = useFlag(LaunchDarklyFlag.ENABLE_SIMPLE_DELIVERY_FORM);
  const isDesktop = useMediaQuery('desktop');

  return (
    <>
      <Box flexDirection="column" center>
        <Box width={isDesktop ? '50%' : '100%'} center margin="0 0 1rem">
          <ActionButton
            type="submit"
            fullWidth
            disabled={!addressString}
            data-testid="deliver-here"
            variant={ActionButtonVariants.PRIMARY}
          >
            {formatMessage({ id: 'deliverHere' })}
          </ActionButton>
        </Box>
        {showDeliveryAddresses && (
          <Box width={isDesktop ? '50%' : '100%'} center margin="0 0 1rem">
            <ActionButton
              data-testid="back-to-saved-addresses"
              fullWidth
              variant={ActionButtonVariants.OUTLINE}
              onClick={() => setCreateAddressView(false)}
              onlyIcon
              wrapText
            >
              {formatMessage({ id: 'backToSavedAddresses' })}
            </ActionButton>
          </Box>
        )}
      </Box>
      {enableSimplifiedDelivery && (
        <AdditionalInformation>
          {formatMessage({ id: 'additionalAddressInformation' })}
        </AdditionalInformation>
      )}
      <DeliveryDisclaimer>
        {formatMessage({ id: 'poweredByThirdPartyDeliveryProviders' })}
      </DeliveryDisclaimer>
    </>
  );
};

export default DeliveryAddressFormFooter;
